module.exports = __webpack_public_path__ + "static/media/ico-diversity.d00ff2c0.svg";